import fade from './initialStates/fade';
import picture from './initialStates/picture';

const initialStates = new Map();

initialStates.set('title', fade);
initialStates.set('paragraph', fade);
initialStates.set('footer', fade);
initialStates.set('picture', picture);

export default initialStates;